<template>
  <!--<div class="page" :class="windowResize==1?'windowW':''" v-wechat-title="$route.meta.title">-->
  <div class="page" :class="bodyHide==1?'border-box overflow':''" v-wechat-title="$route.meta.title">

    <div class="main-scroll-view" style="position: relative; width: 100%; height: auto;">
      <img class="video_play_bg" src="../../assets/video-bg.jpg" alt="">

      <!--顶部视频信息-->
      <div class="list border-box">
        <div class="list-box box border-box">
          <div class="block list-img" id="list-img">
            <img class="img list-video-img" :src="bagInfo.vrimg" alt="" >
          </div>
        </div>

        <div class="list-video-con border-box">
          <div class="list-video-name hide">{{bagInfo.name}}</div>
          <div class="list-time-num clearfix">
            <p class="fl" v-if="bagInfo.dsnum>=0&&bagInfo.buynum<=0&&res.noReward!=1">
              <img src="../../assets/icon_play_btn09.png" />
              {{bagInfo.dsnum|initNumber}}人打赏
            </p>
            <p class="fl" v-else-if="bagInfo.buynum>0&&bagInfo.price>=0">
              <img src="../../assets/icon_18_study.png" />
              {{bagInfo.buynum|initNumber}}人购买
            </p>
            <p class="fl" v-if="bagInfo.comments>=0" @click="scollToComment('comments-list-top')">
              <img src="../../assets/icon_31.png" />
              {{bagInfo.comments|initNumber}}人评论
            </p>
            <p class="fr" v-if="bagInfo.listen>=0">
              {{bagInfo.listen|initNumber}}次播放
            </p>

            <!--<div class="list-share" @click="showPoster">-->
              <!--<img src="../../assets/icon-share-btn.png" alt="">-->
            <!--</div>-->
          </div>
        </div>
      </div>



      <!--新增打赏-->
      <div class="ds-box border-box" @click="rewardShowFun">
        <div v-if="res.dsimgs && res.dsimgs.length>0">
          <img v-for="(item,index) in res.dsimgs"  class="img ds-box-img" v-lazy="item.rzimg?item.rzimg:item.img"/>
          <span class="ds-box-num">已有{{bagInfo.dsnum}}人打赏</span>
        </div>
        <div v-if="!res.dsimgs||res.dsimgs.length==0">
          <span class="ds-box-num">暂无打赏</span>
        </div>
        <span class="fr ds-box-btn">打赏</span>
      </div>


      <p class="split-line" style="margin-top: .34rem;height: .02rem;background: #f1f1f1;"></p>


      <!--新增标题-->
      <div class="list-tit-new border-box clearfix">
        <span>全景景点解说</span>
        <span>包含{{bagInfo.sees}}个讲解点</span>
      </div>

      <div style="position: relative;">
        <div v-for="(item,index) in voice" :key="index" class="video-list border-box clearfix">
          <p class="list-title">
            <img class="icon_gps" src="../../assets/icon_gps1.png" />
            {{item.pspotname}}
          </p>

          <div v-for="(ite,ind) in item.list" :key="ind" class="video-list-info" :id="'video-list-spotid'+ite.spotid">
            <div class="video-list-con" @click="openVR(ite.number)">
              <span class="list-video-mask"></span>
              <img class="icon_360" src="../../assets/icon_360.png" alt="">
              <img class="img video-logo" v-lazy="ite.logo" />
              <!--<img class="video-state" :src="(ite.number == currIndex && isplay==1)?require('../../assets/view-video-bf.png'):require('../../assets/icon_suo_yellow.png')" />-->
              <img v-if="res.isbuy==false&&ite.number>=1" class="video-state" src="../../assets/icon_suo_yellow.png" alt="" />
            </div>
            <p class="spot-name hide">{{ite.spotname}}</p>
          </div>

        </div>
      </div>


      <!--新增附近推荐景区-->
      <div class="conference-list p024 half clearfix mt50" v-if="near!=null&&near.length>0">
        <div class="list-tit">附近推荐景区
          <router-link class="list-more" v-if="near.length>0" :to="{path:'/view-list',query:{siteid:siteid,sort:1,lat:res.bag.lat,lng:res.bag.lng,TimeStamp:TimeStamp,inputValue:'',appKey:appKeyA}}">查看更多</router-link>
        </div>
        <router-link class="conference-item-parent" :to="{path:'/view-detail',query: {shopid: item.id, TimeStamp: TimeStamp, appKey: appKeyA}}" v-for="(item,index) in near">
          <div class='conference-item border-box'>
            <div class="conference-item-img loadBg">
              <img class="img" v-lazy="item.logo" alt="">
            </div>
            <div class="conference-item-info clearfix">
              <div class="label-box">
                <div class="conference-item-title hide" style="max-width: 100%;">{{item.name}}</div>
              </div>
              <div class="right-info">
                <div class='conference-item-info-label'>
                  <img src="../../assets/station-icon-view.png" alt="">
                  <span class="icon-time">{{item.spots}}个讲解点</span>
                </div>
              </div>
            </div>
          </div>
        </router-link>
      </div>


      <!--新增评论头部-->
      <div class="comments-list-top clearfix border-box" id="comments-list-top">
        <span class="fl">游客点评</span>
      <span @click="commentsShow" class="fr commentBtn">我要点评
        <img src="../../assets/icon-write.png" />
      </span>
      </div>

      <!--新增底部评论详情列表-->
      <div class="comments-list border-box account-list-sr">
        <div v-for="(item,index) in commentList" :key="index" class="comments-list-data box border-box">
          <p class="block head-img-box">
            <img class="img" v-lazy="item.rzimg?item.rzimg:item.headimg"/>
          </p>

          <div class="flex comments-list-info  border-box">
            <div class="comments-person-box box ">
              <div class="block comments-person">
                <p class="comments-person-name hide">{{item.name}}</p>
                <p class="star-level">
                  <template v-for="(star,index) in [2,4,6,8,10]">
                    <img v-if="item.score>=star" src="../../assets/icon_com.png"/>
                    <img v-else  src="../../assets/start_nor.png" />
                  </template>
                  <span class="icon-reward-small" v-if="item.isds&&res.noReward!=1">赏</span>
                </p>
              </div>
              <p @click="uploadZan(index)" class="praise">
                <span>{{item.totalZan}}</span>
                <img v-if="item.iszan==1" src="../../assets/zan_already.png" />
                <img v-else src="../../assets/zan_already_no.png" />
              </p>
            </div>

            <div class="comments-detail border-box">
              <p class="comments-detail-top">{{item.content}}</p>
            </div>

            <div v-if="item.allimg" class="comments-img box border-box">
              <img v-for="(ite,index) in item.allimg"  @click="seeImg(index,item.allimg)" v-lazy="ite" />
            </div>

            <div class="block comments-person-time">
              {{item.addtime}}
              <!--<span @click="replay" class="comments-person-hf fr" v-if="res.isguide && item.replys.length<1"><img src="../../assets/icon_play_btn11.png" />回复</span>-->
              <span v-if="item.state==2" class="shz-text fr none">审核中</span>
            </div>

            <div v-if="item.replys" class="comments-detail-replay border-box">
              <div v-for="(item,index) in item.replys" :key="index" class="comments-replay-text">
                <span>{{item.bagname}}</span> 回复
                <span>{{item.name}}</span> ：{{item.content}}
              </div>
            </div>
          </div>
        </div>
        <router-link :to="{path:'/comment',query: {id:this.$route.query.id,isbuy:res.isbuy,isguide:res.isguide, TimeStamp: TimeStamp, appKey: appKeyA}}">
          <div class="bottom-box border-box">
            <p class="select-more">查看共{{commentListLen}}条评论</p>
          </div>
        </router-link>

        <p class="load-tip" ref="loadtip" style="display: none;"></p>
      </div>
    </div>

    <!--底部购买按钮-->
    <div v-if="res.isbuy==false" class="bottom-btn-box border-box box">
      <div @click="scollToComment('comments-list-top')" class="video-listen">
        <img class="icon_play_num" src="../../assets/icon_play_num3.png" />
        <span v-if="bagInfo.comments>0">{{bagInfo.comments}}</span>
      </div>
      <!--<button class="flex bottom-btn" style="background-color:#fff;color:#4d4d4d;" @click="showOTA()">激活码</button>-->
<!--      <button class="flex bottom-btn" @click="buyVideo()">购买收看</button>-->
      <button class="flex bottom-btn" @click="res.isbuy=true">购买收看</button>
    </div>



    <!--返回上一页按钮-->
    <div class="link-btn" @click="back">返回</div>

    <!--点击屏幕加号按钮弹窗事件-->
    <p @click="videoPlay" class="btn-add none">{{memuText}}</p>
    <div class="alert-box alert-box-con" :class="{'none':menuCurr==0,'curr':menuCurr==1}">
      <p @click="videoPlay" class="mask"></p>
      <div class="btn-add-box" @click="videoPlay">
        <p @click.stop="commentsShow" class="animate animate1">评论</p>
        <p @click.stop="feedbackFun" class="animate animate2">反馈</p>
        <router-link class="animate animate3" to="/user">我的</router-link>
      </div>
    </div>


    <!--全景视频弹窗-->
    <div class="video-alert" v-if="videoAlert==1">
      <p class="video-tip" @click="closeVR()">返回<img src="../../assets/h5_logo.png" alt=""></p>
      <div class="video-iframe" id="example">
        <iframe :src="iframeSrc" frameborder="0"></iframe>
        <div class="video-iframe-mask" v-if="res.isbuy==false" @click="buyTip=1"></div>
      </div>
    </div>


    <!--新版本打赏弹窗8-20-->
    <AlertReward :bagInfo="bagInfo" :res="res" :that="that" :dsImgs="res.dsimgs" :class="{'curr':rewardShow==1,'none':rewardShow!=1}" @child-Reward="closeReward"></AlertReward>

    <!--新版本评论弹窗8-21-->
    <AlertComment :bagInfo="bagInfo" :class="{'curr':commentShow==1,'none':commentShow!=1}"  @child-Comment="closeComment"></AlertComment>

    <!--试听结束弹窗新版-->
    <AlertListenEnd  :bag="bag" :couponid="couponid" :extral="extral" @close="closeEnd" v-if="Object.keys(bag).length>0"></AlertListenEnd>

    <!--意见反馈弹窗-->
    <AlertFeedback :class="{'none':feedbackShow==0,'curr':feedbackShow==1}" v-on:child-Feedback="closeFeedback"></AlertFeedback>

    <audio id="Audio" style="overflow: hidden" src="http://wangchuang-1252493175.coscd.myqcloud.com/jpjs/upload/voice/20181126/iosvoicetest.mp3"></audio>


    <!--海报弹窗-->
    <AlertPoster  :id="id" :type="'guide'" @close="closePoster" v-if="posterShow==1"></AlertPoster>

    <!--提醒用户购买弹窗弹窗-->
    <AlertPayTip @close="closePayTip" :comeForm="'2'" :price="bagInfo.price" :buybtn="buyVideo" v-if="buyTip==1"></AlertPayTip>

    <!--OTA-->
    <AlertOTA  :OTAcode="OTAcode" :bagInfo="bagInfo"  @close="closeOTA" v-if="OTAcodeShow==1"></AlertOTA>

    <!--系统维护蒙层-->
    <P400  v-if="P400==1"></P400>



  </div>

</template>

<script>
  import 'photo-sphere-viewer/dist/photo-sphere-viewer.css'
  import 'swiper/dist/css/swiper.css'
  import AlertReward from '../../components/AlertReward'
  import AlertComment from '../../components/AlertComment'
  import AlertListenEnd from '../../components/AlertListenEnd'
  import AlertFeedback from '../../components/AlertFeedback'
  import AlertPoster from '../../components/AlertPoster'
  import AlertOTA from '../../components/AlertOTA'
  import AlertPayTip from '../../components/AlertPayTip'
  import P400 from '../../components/P400'
  import {getVideoPlay, getBagComment, getZan, uploadUserBrowse, getPopComment, getOTAcode} from "@/service/getData";
  import {wxImgPreview, wxShareme,listenEndOrder, creatOrder, pushOrder,playRecord } from '@/utils/wechat'
  import {setStore, getStore, removeStore, loadMore} from '@/config/mUtils'

  import wxConfirm from '@/wechat-messagebox/Confirm'
  import D from '@/wc-messagebox'
  import Vue from 'vue'
  Vue.use(D)

var fromPath,fullPath;
  export default {
    data(){
      return{
        sregion: '', //省站点id:430000
        siteid: '', //站点id
        id: '', //专辑id
        spotid: '', //景点id
        shopid: '', //景区id
        userInfo: {}, //用户信息
        res:{
            isReward: false,  //未打赏过  true已打赏过
            noReward: 1 // 0自愿打赏 1关闭打赏 2强制打赏
        },//接口所有数据
        bagInfo:'',//专辑详情
        voice:[],//语音
        bagList:[],//语音列表
        commentList:[],//评论数据
        commentList1:[],//弹幕评论数据
        commentListLen:0,//评论条数
        commentShow:0,//评论弹窗
        rewardShow:0,//打赏弹窗
        bodyHide:0,//页面是否滚动
        memuText:'菜单',//菜单按钮文字
        menuCurr:0,//菜单按钮动画
        feedbackShow:0,//意见反馈弹窗
        isDs: false, //是否打赏过

        Audio: '', //音频dom
        videoTimer: null, //语音播放计时器
        isplay: 0, //当前语音是否播放
        currSlider: 0, //当前进度条
        currIndex: -1, //当前播放音频数组下标
        index1: 0, //当前播放音频数组下标(用来记录currIndex，传值给下订单方法)
        bag:{}, //当前试听的专辑
        extral:{}, //存放下单需要的值
        couponid: '', //优惠券id

        action: '', //订单推送消息

        currVRindex: -1,//当前播放的VR视频下标
        TimeStamp: new Date().getTime(),  //获取当前时间
        hasVideo:0,//导游是否有视频
        video:'',//导游视频
        videoimg:'',//导游视频封面
        isVideoPlay: false,  //视频没有在播放
        appKey:'',
        appKeyA: '',
        form: '', //来自哪个页面
        posterShow: 0, //分享海报弹窗
        OTAcode: '', //OTA激活码
        OTAcodeShow: 0, //OTA激活码弹窗
        videoAlert:0,//全景视频弹窗
        videoAlertMask:1,//全景视频弹窗蒙层
        near:[],
        vr: null,
        scene: null,
        renderer: null,
        container: null,
        firstTime: true,
        currTime: 0,
        canbtn: false,

        P400: 0, //系统维护中
        PSV: null, //全景图片
        windowResize:'',//手机横竖屏设置 0:竖屏 1：横屏

        buyTip: 0, //购买提醒弹窗
        iframeSrc: 'https://www.kuleiman.com/120859', //  iframe的外链
      }
    },
    computed: {

    },
    created() {
      this.that = this;
      this.global.set_glabalClear();
      this.siteid = getStore("siteid") || "";
      this.sregion = getStore("sregion") || "";
      this.id = this.$route.query.id;
      this.spotid = this.$route.query.spotid;
      this.shopid = this.$route.query.shopid;
      this.form = this.$route.query.form;

      this.appKey = this.$route.query.appKey || "";
      this.appKeyA = this.appKey;
      if(this.appKey){
        this.appKey = encodeURIComponent(this.appKey)
        setStore("appKey", {"appKey":this.appKey});
        this.sendUserBrowse();
      }else{
        setStore("appKey", {"appKey":""});
      }

      this.action = this.$route.query.action;
      if(this.action == "cancel"){
        let self = this;
        this.$confirm({
          title: '提示',
          content: '取消推送授权，退出后将找不到页面入口，需要重新授权吗？',
          component: wxConfirm
        }).then(function(res){
          if(res == 'success') {
            pushOrder('dist/index.html#/video-play?id='+self.id+'&spotid='+self.spotid+'&shopid='+ self.shopid + '&TimeStamp='+ self.TimeStamp + '&appKey='+ (self.appKey));
          }
        }).catch(function(res){
          if(res == 'success') {
            pushOrder('dist/index.html#/video-play?id='+self.id+'&spotid='+self.spotid+'&shopid='+ self.shopid + '&TimeStamp='+ self.TimeStamp + '&appKey='+ (self.appKey));
          }
        })
      }

      this.$loading.show('数据加载中');
      this.initData();
      this.initComment();

      window.addEventListener("scroll",function(){});


    },
    beforeDestroy(){
      window.removeEventListener("scroll",function(){});

    },
    beforeRouteEnter (to, from, next) {
      if(from.path.indexOf('video-vr') > -1){
        fromPath = 'video-vr';
        fullPath = to.fullPath;
      }
      next();
    },
    mounted(){

      if(fromPath == 'video-vr'){
        this.$router.replace({
          path: fullPath
        });
      }
      if(this.form == 'pay'){
        window.addEventListener("popstate", function(e) {
          window.history.go(-6);
        }, false);
        pushHistory();
        function pushHistory() {
          var state = {
            title: "title",
            url: ""
          };
          window.history.pushState(state, "title", "");
        }
      }

    },
    methods: {

      async initData(){
        var self = this;
        this.userInfo = getStore("userInfo");

        let res = await getVideoPlay({
          TimeStamp: this.TimeStamp,
          openid: this.userInfo.openid,
          bagid: this.id,
          siteid: this.siteid,
          sregion: this.sregion,
          page:1,
          rows:4
        });

        if (res.errcode === "00000"){
          this.$loading.hide();
          this.res = res.data;
          this.bagInfo = res.data.bag;
          setStore("bagInfo",this.bagInfo);
          this.voice = res.data.voice;
          this.bagList = res.data.voiceList;
          this.near = res.data.nearshop;

          //新增start
          if(res.data.bag.video!='null'&&res.data.bag.video!=''){
            this.video = res.data.bag.video;
            this.videoimg = res.data.bag.videoimg;
          }
          //新增end

          if(this.$route.query.rewardShow == 1){
            this.rewardShow = 1
          }

          if(this.form == "spot"){
            this.index1 = this.getIndex(this.bagList,this.spotid);
          }

          if(res.data.isPosition == 1){
            setTimeout(function(){
              self.scollToComment('video-list-spotid'+self.spotid,-50);
            },1000);
          }else {
            document.documentElement.scrollTop = document.body.scrollTop = 0;
          }

          var share = res.data.share;
          let link = '/video-vr?id='+ this.id +'&spotid='+ this.spotid +'&shopid='+ this.shopid +'&TimeStamp='+ this.TimeStamp+'&appKey='+(this.appKey);
          if(share == null){
            let title = '金牌解说 | ' + this.bagInfo.name;
            let desc = '我是'+ this.bagInfo.guidename2 +'，我在“金牌解说”为您讲解'+ this.bagInfo.shopname +'的历史故事';
            let img = this.bagInfo.tvideourl;
            wxShareme(title,desc,img,link);
          }else {
            wxShareme(share.title,share.desc,share.logo,link);
          }

          this.$route.meta.title = this.bagInfo.shopname;


        }else {
          this.$toast(res.errmsg)
          this.P400 = 1;
          this.$route.meta.title = '请稍后访问...';
        }

        let res1 = await getPopComment({
          TimeStamp: this.TimeStamp,
          page: 1,
          roes: 10,
          bagid: this.id
        });
        if (res1.errcode === "00000"){
          if (res1.data.length > 0) {
            this.commentList1 = res1.data;
          }
        }
      },

      //上传浏览数据
      async sendUserBrowse(){
        this.userInfo = getStore("userInfo");
        let res = await uploadUserBrowse({
          openid: this.userInfo.openid,
          appKey: this.appKey,
        });
      },

      async initComment(){
        let res = await getBagComment({
          TimeStamp: this.TimeStamp,
          openid: this.userInfo.openid,
          page: 1,
          rows: 5,
          bagid: this.id
        });

        if (res.errcode === "00000"){
          if (res.data.root.length > 0) {
            this.commentList = res.data.root;
            this.commentListLen = res.data.total;
          }
        }
      },

      //页面滑动到指定标签id位置
      scollToComment(elmid,top){
        let self = this;
        self.$nextTick(function() {
          var dom = document.getElementById(elmid);
          if(dom && dom != null){
            if(top){
              window.scrollTo(0,Number(self.offSet(dom)+top));
            }else {
              window.scrollTo(0,self.offSet(dom));
            }
          }
        });
      },

      offSet(curEle){
        var totalTop = null;
        var par = curEle.offsetParent;
        //首先把自己本身的相加
        totalTop += curEle.offsetTop;
        //现在开始一级一级往上查找，只要没有遇到body，我们就把父级参照物的边框和偏移相加
        while (par){
          //把父级参照物的偏移相加
          totalTop += par.offsetTop;
          par = par.offsetParent;
        }
        return totalTop;
      },

      //打赏弹窗显示隐藏
      rewardShowFun(){
        this.rewardShow = 1;
      },
      //评论弹窗隐藏
      closeComment :function(msg){
        this.commentShow = msg.commentShow;
        if(msg.success){
          this.initComment();
        }
      },
      //打赏弹窗隐藏
      closeReward :function(msg){
        this.rewardShow = msg.rewardShow;
        if(msg.success){
//          this.initData();
          this.bagInfo.dsnum++;
        }
      },
      //意见反馈弹窗隐藏
      closeFeedback :function(feedbackClose){
        this.feedbackShow = feedbackClose
      },
      //菜单按钮动画
      videoPlay(){
        if(this.menuCurr==1){
          this.menuCurr=0
          this.memuText='菜单'
        }else{
          this.menuCurr=1
          this.memuText='关闭'
        }
      },

      //关闭购买提醒弹窗
      closePayTip(msg){
         this.buyTip = msg;
      },

      //显示与隐藏意见反馈
      feedbackFun(){
        if(this.feedbackShow==0){
          this.feedbackShow=1
          this.menuCurr = 0
          this.memuText = '菜单'
        }else{
          this.feedbackShow=0
          this.menuCurr = 1
          this.memuText = '关闭'
        }
      },

      //评论弹窗显示隐藏
      commentsShow(){
        if(!this.res.isbuy){
          this.menuCurr = 0
          this.memuText = '菜单'
          this.$toast('请先购买')
        }else{
          //this.bodyHide = 1
          this.menuCurr = 0
          this.memuText = '菜单'
          this.commentShow = 1
        }
      },

      //用户评论点赞
      async uploadZan(index){
        let res = await getZan({
          TimeStamp: this.TimeStamp,
          openid: this.userInfo.openid,
          commentid: this.commentList[index].id
        });
        if(res.errcode == "00000"){
          this.commentList[index].totalZan++;
          this.commentList[index].iszan = 1;
          this.$toast("点赞成功",{ location: ''})
        }else{
          this.$toast(res.errmsg,{ location: ''})
        }
      },



      //点击购买，调用下订单公用方法
      buyVideo(){
        let self = this;

        setStore("source", {"source": "video"});
        setStore("couponid", {"couponid": ""});
        self.$router.push({
          path: `/pay?${'pid='+self.bagInfo.id+'&cid='+self.couponid+'&shopid='+self.bagInfo.shopid+'&bagtype=2'+'&appKey='+(self.appKey)}`
        });
      },

      //关闭试听弹窗，购买成功修改音频状态
      closeEnd(msg){
        this.bag = msg.bag;
        if(msg.isbuy){
          this.res.isbuy = true;
        }
      },

      //拿到数组中指定spotid的下标
      getIndex(arr,spotid){
        let result;
        if(arr.find(function(x) {return x.spotid == spotid;}) != undefined) {
          arr.find(function(x,i) {
            if(x.spotid == spotid){
              result =  i;
            }
          });
          return result;
        }else {
          return 0;
        }
      },

      //跳转到导游详情页
      goGuideInfo(id){
        this.$router.push({
          path: `/guide-info?${'id='+ id + '&TimeStamp='+ this.TimeStamp+'&appKey='+(this.appKey)}`
        });
      },

      //图片预览
      seeImg(ind,imgs){
        wxImgPreview(imgs[ind],imgs);
      },


      //显示分享海报弹窗
      showPoster(){
        this.posterShow = 1;
      },

      //关闭分享海报弹窗
      closePoster(msg){
        this.posterShow = msg;
      },

      //关闭OTA弹窗
      closeOTA(msg){
        this.OTAcodeShow = 0;
        if(msg.isbuy){
          this.res.isbuy = true;
        }
      },

      //显示OTA弹窗
      async showOTA(){
        let res = await getOTAcode();
        console.log(res)
        if (res.errcode === "00000"){
          this.OTAcode = res.data
        }
        this.OTAcodeShow = 1
      },

      //点击上一曲
      prevPlay(){
        var playIndex = parseInt(this.currVRindex) == 0 ? (this.bagList.length -1) : (parseInt(this.currVRindex) - 1);
        this.openVR(playIndex);
      },
      //点击下一曲
      nextPlay(){
        var playIndex = (parseInt(this.currVRindex) == this.bagList.length -1) ? 0 : (parseInt(this.currVRindex) + 1);
        this.openVR(playIndex);
      },

      //打开全景视频
      openVR(index){
          var self = this;
          if(index==-1){
              this.initVR(this.currVRindex);
          }else {
              if(this.res.isbuy == true || index < 1){
                  this.videoAlert=1;
                  if(this.currVRindex<0){
                      this.videoAlertMask=1;
                  }
                  this.initVR(index);
              }else {
                  this.buyTip = 1;
              }
          }
      },

      //关闭全景
      closeVR(){
        var self = this;
        self.videoAlert=0;
      },

      initVR(index) {
        if(this.iframeSrc == 'https://www.kuleiman.com/120859'){
            this.iframeSrc = 'https://www.kuleiman.com/120861'
        }else if(this.iframeSrc == 'https://www.kuleiman.com/120861'){
            this.iframeSrc = 'https://www.kuleiman.com/120363'
        }

      },


      //返回上一页
      back(){
        MtaH5.clickStat("video_back");//专辑详情页面点击返回上一页
        this.$router.go(-1);//返回上一层
      },

    },
    watch:  {
      bag(newVal,oldVal){
        if(Object.keys(newVal).length){
          listenEndOrder(this,this.index1,this.bagInfo,true);
        }
      },

    },
    components: {
      AlertReward,
      AlertComment,
      AlertListenEnd,
      AlertFeedback,
      AlertPoster,
      wxConfirm,
      AlertOTA,
      AlertPayTip,
      P400
    },
    //格式化数据
    filters: {
      //格式化数字
      initNumber: function (num) {
        if(num>10000){
          num = (num/10000).toFixed(2)+'万'
        }else if(num>1000){
          num = (num/1000).toFixed(2)+'千'
        }
        return num;
      },
      //格式化时间
      initTime: function (time) {
        let minute = parseInt(time / 60);
        let second = parseInt(time % 60);
        minute = minute >= 10 ? minute : "0" + minute;
        second = second >= 10 ? second : "0" + second;
        return minute + ":" + second;
      }
    },
  }

</script>

<style scoped>
  @import '../../style/alert.css';


  .page{padding-bottom:1.14rem; background-color: #fff; }
  .video_play_bg{width: 100%;height: 2.64rem;object-fit: cover; }
  /*顶部视频信息*/
  .list{ position: relative;background: #fff;margin: -1.53rem .26rem 0;border-radius: .1rem;box-shadow: 0 0 0.25rem #f0f0f0;}
  .list-box{width:100%;height:3rem;border-radius: .1rem .1rem 0 0;overflow: hidden;}
  .list-img{ position: relative;width: 100%;height: 100%;}
  .list-img img.list-video-img{display:block;width:100%;height:100%;border-radius:  .1rem .1rem 0 0;object-fit: cover;}
  .list-video-mask{position: absolute;z-index:1;top:0;left: 0;width: 100%;height: 100%;background: rgba(0,0,0,.52);}
  .list-video-con{padding: .24rem .28rem .22rem;}
  .list-video-name{font-size: .32rem;color: #000;}
  .list-time-num {height:.42rem;line-height:.42rem; margin-top: .45rem; }
  .list-time-num>p{display: inline-block;line-height:.42rem;margin-right:.22rem;font-size: .24rem; color: #676767;}
  .list-time-num img{float:left;width:auto;height:.4rem;margin-right: .16rem;margin-top: .01rem}
  .list-time-num>p.fr{margin-right: 0;font-size: .2rem;color: #757575;}

  /*打赏内容*/
  .ds-box{height: .9rem;margin: .2rem .28rem 0;padding-left:.22rem;padding-right:.22rem;border-radius: .5rem;box-shadow: 0 0 0.25rem #f1f1f1;}
  .ds-box-img{float: left;width: .6rem;height: .6rem;margin-left:-.06rem;margin-top:.15rem;border-radius: 50%;object-fit: cover;}
  .ds-box-img:first-child{margin-left: 0;}
  .ds-box-img:nth-of-type(n+4){display: none;}
  .ds-box-num{float: left;margin-left: .22rem;font: .24rem/.9rem "Microsoft YaHei";color: #676767;}
  .ds-box-btn{width: .7rem;height: .7rem;text-align: center;margin-top: .1rem;font: .22rem/.7rem "Microsoft YaHei";color: #fff;border-radius: 50%;background: #ffc53f;}

  /*新增标题*/
  .list-tit-new{padding: .24rem .18rem 0;line-height: .4rem;font: bold .32rem/.4rem "Microsoft YaHei";color: #333;}
  .list-tit-new span{float: left;}
  .list-tit-new span:last-child{height:.28rem;padding:0 .06rem;margin-left: .08rem;margin-top:.06rem;border-radius: .3rem;background: #39affa;font: .18rem/.28rem "Microsoft YaHei";color: #fefefe;}


  /*视频列表*/
  .icon_gps{position:absolute;left:0;top:50%;width:.26rem;height:.24rem;transform:translateY(-40%);}
  .video-list{position:relative;width:100%;padding:.30rem .22rem;border-bottom:.01rem solid #f0f0f0;}
  .list-title{position:relative;font-size:.28rem;color:#ffc53f;padding-left:.42rem;}
  .video-list-info{float:left;width:50%;margin-top:.30rem;}
  .video-list-con{position:relative;display:block;width:3.20rem;height:3.20rem;margin:0 auto;background:url(https://jpjs.geeker.com.cn/frame/images/default_bg.png) no-repeat 50% ;}
  .video-list-con img.video-logo{width:100%;height:100%;background: none;}
  .video-list-con img.video-state{position:absolute;z-index:1;top:.13rem;right:.16rem;width: .27rem;height: auto;}
  .video-list-info .spot-name{display:block;width:3.20rem;height:.32rem;line-height:.32rem;margin:.10rem auto 0;font-size:.28rem;color:#666;}
  .video-list-info .spot-name.curr{color:#faaf39;}
  .video-list-info .spot-name .recommend-star{float:left;display:inline-block;width:.20rem;height:.20rem;margin-right:.10rem;margin-top:.05rem;}
  .icon_360{position: absolute;z-index: 1;top:50%;left:50%;width: auto;height: .52rem;-webkit-transform: translate(-50%,-50%);transform: translate(-50%,-50%);}

  /*底部购买按钮*/
  .bottom-btn-box{position:fixed;left:0;bottom:0;width:100%;height:1.14rem;background: #fff;z-index:1;box-shadow:0 0 .05rem #ddd;}
  .bottom-btn{ position: relative; display: block; height:1.14rem;line-height:1.14rem;color:#fff;background: #faaf39;z-index:1;text-align:center;font-size:.36rem;letter-spacing:.04rem;}
  .video-listen{position:relative;width:1.50rem;height:1.14rem;}
  .video-listen span{position:absolute;top:.22rem;left:initial;right:16%;padding:.03rem .07rem;font-size:.18rem;color:#fff;background:#f96900;border-radius:.10rem;min-width:.24rem;text-align:center;}
  .btn-video-box.box1 .video-listen{position:absolute;left:0;top:50%;width:1.20rem;height:.45rem;-webkit-transform:translateY(-50%);transform:translateY(-50%);}
  .btn-video-box.box1 .video-listen span{position:absolute;top:-.20rem;left:initial;right:.12rem;padding:.03rem .10rem;font-size:.20rem;color:#fff;background:#faaf39;border-radius:.10rem;}
  .icon_play_num{position:absolute;top:50%;left:50%;width:.54rem;height:.50rem;margin:0 auto;transform:translate(-50%,-50%);}

  /*附近景区*/
  .list-tit{padding:.2rem 0;height:.36rem;color:#333;font-weight:bold;font-size:.32rem;line-height:.36rem}
  .list-tit span{float:left;margin-right:.12rem;width:.07rem;height:.36rem;background-color:#faaf39}
  .list-more{float:right;padding:0 .07rem;color:#555;font-size:.24rem}
  .conference-item-info-label img{width:.17rem;height:.26rem;vertical-align: middle;}
  .half .conference-item-parent{float: left;width:50%;}
  .half .conference-item-parent .conference-item{position: relative;margin-top: .2rem;background-color: #fff;border-radius: .15rem;}
  .half .conference-item-parent:nth-of-type(odd) .conference-item{padding-right:3%;}
  .half .conference-item-parent:nth-of-type(even) .conference-item{padding-left:3%;}
  .half .conference-item-parent .conference-item-img{position:relative;width:100%;height:2.7rem; border-radius: .08rem .08rem 0 0;overflow: hidden;}
  .half .conference-item-parent .conference-item-info{height:1rem; padding-left: .17rem; border-radius: 0 0 .08rem .08rem;box-shadow: 0 .06rem .1rem rgba(102,102,102,.1); }
  .half .conference-item-parent .conference-item-title{font-weight: bold;color: #333;font-size:.26rem;}
  .half .conference-item-parent .label-box{width: 100%;height:.48rem; line-height: .48rem; padding-top: .08rem; }
  .half .conference-item-parent .right-info{width: 100%;text-align: left;}
  .half .conference-item-parent .icon-time {font-size: .22rem;margin-left: .07rem;font-weight: bold;color: #666;}


  /*新增底部评论详情列表*/
  .comments-list{width:100%;padding:.36rem 0  .16rem .24rem; margin-bottom: 0; }
  .comments-list-top{width:100%;height:.88rem;padding:0 .22rem;margin-top: .4rem;border-bottom:1px solid #F0F0F0;}
  .comments-list-top .fl{font:bold .32rem/.88rem "Microsoft YaHei";color:#333;}
  .comments-list-top .fr{font:.28rem/.88rem "Microsoft YaHei";color:#666;}
  .comments-list-top .fr img{float:right;width:.29rem;height:.32rem;margin:.28rem 0 0 .16rem;}
  .comments-list .bottom-box{position:relative;width:100%;height:.88rem;background:#fff;}
  .select-more{height:.88rem;line-height:.88rem;font-size:.30rem;color:#faaf39;text-align:center;background: none;}
  .icon-reward-small{float:left;height:.26rem;line-height:.26rem;margin-top:-.03rem;margin-left:.05rem;padding:0 .10rem;font-size:.16rem;color:#fff;background:#f5681b;border-radius:.05rem;}
  .shz-text{margin-right:.24rem;color:#ff5400;font-size:.24rem;}


  /*视频弹窗*/
  .video-alert{position: fixed;z-index:999;left:0;top:0;width: 100vw;height: 100vh;background: rgba(0,0,0,1);}
  .video-tip{position: absolute; z-index: 999; top: 45px; right: 0; width: 78px; height: 32px; line-height: 32px; padding-left: 15px; font-size: 14px; letter-spacing: 2px; color: #333; background: #fff; border-radius: 50px 0 0 50px; }
  .video-tip > img{ width: 26px; height: 26px; vertical-align: middle;  float: right; margin-top: 3px; margin-right: 5px; }
  .video-alert-mask{position:absolute;left:0;top:0;z-index: 2;width: 100%;}
  .video-alert-mask img{display: block;width: 63.6%;height: auto;margin: 18.5% auto 0;}
  .video-alert-btn{display: block;width: 1.62rem;height: .59rem;margin:1.7rem auto 0;text-align: center;font: bold .26rem/.59rem "Microsoft YaHei";color: #fff;border:1px dashed #fff;border-radius: .2rem;}
  .video-iframe,.video-iframe iframe{ position: relative; width: 100%; height: 100%; }
  .video-iframe-mask{ position: absolute;z-index: 2;left: 0;right: 0;bottom:0;height: 100%; }

  /*分享按钮*/
  .list-share{ position:absolute;bottom: .2rem;right: .28rem;z-index:9; width: .41rem; height: .72rem; }
  .list-share img{ width: 100%; height: auto; }

  /*返回上一页按钮*/
  .link-btn{position: fixed;z-index:2;right:0;bottom:4rem;height: .6rem;padding:0 .28rem;font: .28rem/.6rem "Microsoft YaHei";color:#fff;border-radius: .3rem 0 0 .3rem;background: rgba(0,0,0,.7);}

</style>

<style>

  /*流畅度切换*/
  .change-box{ position:inherit;right:0;bottom:.38rem; width: 1.37rem;  }
  .change-box p{ position: relative;font-size:.28rem;color:#fff;text-align: center; text-indent: .22rem; }
  .change-box > p:before{ position: absolute; left: .3rem; top: .12rem; width: .12rem; height: .12rem; background-color: #faaf39; border-radius: 100%; content: ''; }
  .change-main{ position: absolute; right: 0; top: -2.2rem; z-index: 1; padding: .33rem 0; width: 100%; height: 1.16rem; background-color: rgba(0,0,0,.6); }
  .change-main p{ line-height: .58rem; font-size: .28rem; color: #fff;  }
  .change-main p:before{ position: absolute; left: .3rem; top: .22rem; width: .12rem; height: .12rem; background-color: #faaf39; border-radius: 100%; content: ''; }
  .change-main.LC .change-mode1{  color: #faaf39;  }
  .change-main.GQ .change-mode2{  color: #faaf39;  }

  /*横屏样式*/
  .windowW .video-alert-mask img{width: auto;height: 50vh; margin: 5vh auto;}
  .windowW .video-close{ top:.2rem;right:.2rem;-webkit-transform: scale(.5);transform: scale(.5);-webkit-transform-origin: right top;transform-origin: right top;}
  .windowW .video-alert-btn{margin-top:1vh;-webkit-transform: scale(.6);transform: scale(.6);}
  .windowW #_toolBarcenter,.windowW ._toolBarArea{height: .5rem!important;}
  .windowW #_toolBarpre,.windowW ._toolBarBtn,.windowW #_toolBarnext,.windowW #_toolBarreplay{position:absolute!important;bottom: 0 !important;width: .4rem!important;height: .4rem!important;-webkit-transform: scale(.8);transform: scale(.8);-webkit-transform-origin: left center;transform-origin: left center;}
  .windowW ._toolBarBtn{left: 1rem!important;}
  .windowW #_toolBarreplay{left: .77rem!important;}
  .windowW #_toolBarnext{left: 1.5rem!important;}
  .windowW #_toolBarchange{top:50%;bottom: inherit!important;-webkit-transform: translateY(-50%);transform: translateY(-50%);font: .22rem/.32rem "Microsoft YaHei"!important;}
  .windowW ._toolBarTime{bottom: .5rem!important;font-size: .16rem!important;}
  .windowW ._toolBarA5,.windowW ._toolBarA7{position: fixed!important;z-index:3;-webkit-transform: scale(.5);transform: scale(.5);-webkit-transform-origin: left top;transform-origin: left top;}
  .windowW ._toolBarA5{ left: .3rem!important;top: .2rem!important;}
  .windowW ._toolBarA7{ left: .3rem!important;top: .7rem!important;}
  .windowW ._toolBarA10{display: none!important;}
  .windowW ._toolBarA18{top:50%;bottom: inherit!important;-webkit-transform: translateY(-50%);transform: translateY(-50%); }
  .windowW .change-box p{font-size: .2rem;-webkit-transform: scale(.6);transform: scale(.6); }
  .windowW .change-main{ top: -1.44rem;padding: .1rem 0;-webkit-transform-origin: bottom;transform-origin: bottom;}
  .windowW ._toolBarA11,.windowW ._toolBarA12,.windowW ._toolBarA13{ height: .03rem!important;}
</style>




// WEBPACK FOOTER //
// src/page/video-vr/video-vrlink.vue